import * as React from "react";
import * as main from "../../styles/main.module.scss";
import * as quote from "./style.module.scss";
export const Quote = () => {
  return (
    <section className={quote.quote}>
      <div className={main.containerFluid}>
        <div className={quote.quote__container}>
          <div className={quote.quote__wrapper}>
            <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/ichaak.png" alt=""/>
            <div className={quote.quote__block}>
              <p className={quote.quote__text}>«Я желаю вам не жизнь без трудностей, а новых трудностей и быть к ним подготовленными»
              </p>
              <p className={quote.quote__name}>Ицхак Адизес</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
